import _regeneratorRuntime from "@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { clonePseudoElements } from './clonePseudoElements';
import { createImage, toArray } from './util';

function cloneSingleNode(node) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    var dataURL;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (!(node instanceof HTMLCanvasElement)) {
              _context.next = 5;
              break;
            }

            dataURL = node.toDataURL();

            if (!(dataURL === 'data:,')) {
              _context.next = 4;
              break;
            }

            return _context.abrupt("return", Promise.resolve(node.cloneNode(false)));

          case 4:
            return _context.abrupt("return", createImage(dataURL));

          case 5:
            return _context.abrupt("return", Promise.resolve(node.cloneNode(false)));

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
}

function cloneChildren(nativeNode, clonedNode, filter) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    var children;
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            children = toArray(nativeNode.childNodes);

            if (!(children.length === 0)) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", Promise.resolve(clonedNode));

          case 3:
            return _context2.abrupt("return", children.reduce(function (done, child) {
              return done.then(function () {
                return cloneNode(child, filter);
              }).then(function (clonedChild) {
                if (clonedChild) {
                  clonedNode.appendChild(clonedChild);
                }
              });
            }, Promise.resolve()).then(function () {
              return clonedNode;
            }));

          case 4:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
}

function decorate(nativeNode, clonedNode) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
    return _regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (clonedNode instanceof Element) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", clonedNode);

          case 2:
            return _context3.abrupt("return", Promise.resolve().then(function () {
              return cloneCssStyle(nativeNode, clonedNode);
            }).then(function () {
              return clonePseudoElements(nativeNode, clonedNode);
            }).then(function () {
              return cloneInputValue(nativeNode, clonedNode);
            }).then(function () {
              return clonedNode;
            }));

          case 3:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3);
  }));
}

function cloneCssStyle(nativeNode, clonedNode) {
  var source = window.getComputedStyle(nativeNode);
  var target = clonedNode.style;

  if (source.cssText) {
    target.cssText = source.cssText;
  } else {
    toArray(source).forEach(function (name) {
      target.setProperty(name, source.getPropertyValue(name), source.getPropertyPriority(name));
    });
  }
}

function cloneInputValue(nativeNode, clonedNode) {
  if (nativeNode instanceof HTMLTextAreaElement) {
    clonedNode.innerHTML = nativeNode.value;
  }

  if (nativeNode instanceof HTMLInputElement) {
    clonedNode.setAttribute('value', nativeNode.value);
  }
}

export function cloneNode(nativeNode, filter, isRoot) {
  return __awaiter(this, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee4() {
    return _regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            if (!(!isRoot && filter && !filter(nativeNode))) {
              _context4.next = 2;
              break;
            }

            return _context4.abrupt("return", Promise.resolve(null));

          case 2:
            return _context4.abrupt("return", Promise.resolve(nativeNode).then(cloneSingleNode).then(function (clonedNode) {
              return cloneChildren(nativeNode, clonedNode, filter);
            }).then(function (clonedNode) {
              return decorate(nativeNode, clonedNode);
            }));

          case 3:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
}